module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeUlEQVQYlWP4//8/AxpO+Q8ByehyLF9/M6ADHijNiy7B8vEXhmKcgOXdTxIUv/nOkMrAwMCNJGaPRsPAF8aVt///J9rkV98Z0rCYHMDAwLCBgYHhIJL4Z5ZX3xlmYzEkAKpwAqqbfxDrCAYGlnekKMYSzl+g9Cd0CQCGlUDqVuuZCAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/pmap/add.png
// module id = oRpc
// module chunks = 157